import {  
  MerchantAccountService,
} from "../../../shared/services";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  Input,
  ModalComponent,
  RedButton,
  ToastService,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import React from "react";
import { firstValueFrom } from "rxjs";
import { MerchantAccount } from "../../../shared/models";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";
import styled from "styled-components";

type Props = {
  onClose: (deleted: boolean) => void;
  merchantAccount: MerchantAccount;
  navigate: NavigateFunction;
};

const MerchantAccountPopupWrapper = styled.div`
  .delete-merchant-input {
    width: 400px;
    margin-bottom: 10px;
  }
`
const DeleteMerchantAccountPopUp: React.FC<Props> = ({
  onClose,
  merchantAccount,
  navigate,
}) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);
  const [name, setName] = React.useState("");

  const onEnterName = (name: string) => {
    setName(name);
  };

  function body() {
    return (
      <FlexContainer
        fxLayout="column"
        justifyContent="center"
        alignItems="center"
        spacing={23}
      >
        <CustomLabel textAlign="center">
          To delete the Merchant Account below enter the name exactly as it
          appears in the text input below.
        </CustomLabel>
        <CustomLabel fontWeight={"700"} fontSize={'20px'} lineHeight="26px">{merchantAccount.name}</CustomLabel>
        <Input
          type="text"
          placeholder="Enter Merchant Account Name here to delete..."
          value={name}
          onChange={(e) => onEnterName(e.target.value)}
          className="styled-input delete-merchant-input"
        />
        <CustomLabel color="red" fontSize={'14px'}>
          Deleting a Merchant Account is permanent.
        </CustomLabel>
      </FlexContainer>
    );
  }

  const onDelete = async () => {
    if (isAPIRequestPending) return;
    setAPIRequestPending(true);

    const data = merchantAccount.createAPIModel2();
    const apiModel = {
      accountId: AuthService.authData.accountId,
      merchantAccount: data,
    };

    const result = await firstValueFrom(
      MerchantAccountService.deleteMerchantAccount(apiModel)
    );

    if (!result?.result) {
      ToastService.showError(`Error in deleting merchant account`);
    } else {
      ToastService.showSuccess(`Merchant Account deleted successfully`);
      onClose(true);
    }
  };

  return (
    <MerchantAccountPopupWrapper>
      <ModalComponent
        title="Delete Merchant Account"
        titleFontSize="22px"
        bodyPadding="50px 60px 20px 60px"
        showFooter={true}
        minHeight="240px"
        wrapperWidth="550px"
        bodyBackgroundColor="#fff"
        footerBackground="#FF00001A"
        footerHeight="auto"
        redHeader={true}
        blueHeader={false}
        onClose={() => onClose(false)}
        footerContent={
          <FlexContainer
            alignItems="center"
            justifyContent="center"
            spacing={15}
          >
            <RedButton
              minWidth="120px"
              height="40px"
              onClick={() => onClose(false)}
            >
              Do Not Delete
            </RedButton>
            <RedButton
              primary
              disabled={isAPIRequestPending || name !== merchantAccount.name}
              minWidth="120px"
              height="40px"
              onClick={() => onDelete()}
            >
              Delete
            </RedButton>
          </FlexContainer>
        }
      >
        {body()}
      </ModalComponent>
    </MerchantAccountPopupWrapper>
  );
};

export default withRouter(observer(DeleteMerchantAccountPopUp));
